export default __webpack_public_path__ + "static/media/privacy-policy.20361433.svg";